module.exports = __webpack_public_path__ + "img/sdg.a1baaebf.svg";